import styled from 'styled-components';

import { cssBreakpoints } from 'theme';

export const TileGridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
`;

export const TileGridTileContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 400px;

  --tile-grid-tiles-per-row: 1;
  width: calc(100% / var(--tile-grid-tiles-per-row));

  @media all and (min-width: ${cssBreakpoints.xsUp}) {
    --tile-grid-tiles-per-row: 2;
  }

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    --tile-grid-tiles-per-row: 2;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    --tile-grid-tiles-per-row: var(--tile-grid-container-tiles-per-row);
  }
`;
